/* src/app/core/shared/components/confirm-dialog/confirm-dialog.component.css */
.confirm-overlay {
  position: fixed;
  inset: 0;
  z-index: 3100;
  background: rgba(15, 23, 42, 0.44);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}
.confirm-dialog {
  width: min(480px, 100%);
  background: #ffffff;
  border-radius: 18px;
  padding: 22px;
  box-shadow: 0 24px 70px rgba(15, 23, 42, 0.26);
}
.confirm-header {
  display: flex;
  align-items: flex-start;
  gap: 14px;
}
.confirm-icon {
  width: 38px;
  height: 38px;
  flex: 0 0 auto;
  border-radius: 999px;
  background: #dbeafe;
  color: #1d4ed8;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 900;
}
.confirm-icon-danger {
  background: #fee2e2;
  color: #b91c1c;
}
.confirm-title {
  font-size: 17px;
  font-weight: 800;
  color: #111827;
}
.confirm-message {
  margin-top: 6px;
  color: #475569;
  font-size: 14px;
  line-height: 1.45;
}
.confirm-actions {
  margin-top: 22px;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
@media (max-width: 576px) {
  .confirm-actions {
    flex-direction: column-reverse;
  }
  .confirm-actions button {
    width: 100%;
  }
}
/*# sourceMappingURL=confirm-dialog.component.css.map */
